import React from "react";
import { Landing } from "../components/Landing";

// Page d'accueil. Aussi servie, à l'identique, sur les anciennes URL listées dans HOME_ALIASES
// (config/providersData.js) : même contenu, canonical vers /.
export function HomePage() {
  return <Landing />;
}
